// Small language pack. Add more if needed.
export default {
    en: 'English',
    de: 'German',
    it: 'italien',
    es: 'Spanish',
    nl: 'Dutch',
    hr: 'Croatian',
    fr: 'French'
};


// WEBPACK FOOTER //
// ./src/i18n/languages.js